"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOldSeries = void 0;
const OLD_SERIES = [3359, 3375, 19722, 19648, 3361, 3357, 3373, 19946, 19646, 19720];
const isOldSeries = (seriesId) => OLD_SERIES.includes(seriesId);
exports.isOldSeries = isOldSeries;
